import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CaveShadows1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CAVE_SHADOWS1;
}

export default CaveShadows1PoiTileEntity;
